import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/index.css'
import './styles/animations.css'

// Borra la caché `api-cache` que dejó el service worker anterior (issue #102).
//
// Quitar la regla de `vite.config.ts` impide que se sigan guardando respuestas
// de `/v1`, pero NO borra las que ya están en el disco de quien abrió la app
// antes del arreglo: ahí puede haber respuestas de un tenant al alcance de
// otro. Quedan inertes —sin regla, nadie las lee— pero "inerte" no es
// "borrada", y datos de un cliente no se dejan tirados en el navegador de
// otro. Esto corre en la página, no en el SW, así que limpia también a los
// clientes que todavía no hayan recibido el SW nuevo.
//
// Se puede retirar cuando ya no queden navegadores con el SW viejo.
if ('caches' in window) {
  void caches.delete('api-cache')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
